// extracted by mini-css-extract-plugin
export var sliderRange = "_qe-2";
export var sliderRoot = "_qe-0";
export var sliderThumb = "_qe-3";
export var sliderTrack = "_qe-1";